export default __webpack_public_path__ + "static/media/783.c7e4d05d.png";